import { OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/regionDryingPeriods";

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const withDeleted = ["true", "all"].includes(params.customFilters?.isDeleted?.value as string);
    const query = queryCollection(params, { filter: { ...preparedFilter }, orderBy: "id desc" }).substr(1);
    return request(
        `${resource}/getList?withDeleted=${withDeleted}&${query}`,
        { method: "GET" },
        { countInHeaders: true },
    );
};

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));
const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));
const getItem = (id: number) => request(`${resource}/get/${id}`, { method: "GET" });
const restore = (params: {}) => alertRequest(`${resource}/restore`, body(params));

export { apply, delItem, index, getItem, restore };
